/* The dot between two facts: present for the eye, silent for a screen reader
   (the facts are separate spans already), and a step quieter than the facts. */
.sep { opacity: .55; }
